module.exports = __webpack_public_path__ + "img/4_1.71fb24da.png";